"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/PosterInput.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Image_template = require("../../components/Image/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Image_tag = marko_loadTag(Image_template),
    Locale_template = require("../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value"),
    marko_attrs0 = {
        "class": "btn theme-bg-transparent btn-lg border-top rounded-0 position-absolute w-100 left-0 bottom-0"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", {
      style: marko_styleValue(input.style || {
          height: "10rem"
        }),
      "class": "position-relative border rounded overflow-hidden"
    }, "0", component, null, 1);

  Image_tag({
      alt: "Image",
      src: input.src,
      defaultStyle: "height:100%",
      icon: input.icon,
      class: "w-100"
    }, out, __component, "1");

  if (input.btn) {
    out.be("button", marko_attrs0, "2", component, null, 0, {
        onclick: __component.d("click", () => component.emit('click'), false)
      });

    Locale_tag({
        text: input.btn
      }, out, __component, "3");

    out.ee();
  }

  out.ee();
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
